import { render, staticRenderFns } from "./Modems.vue?vue&type=template&id=4f74b990&scoped=true"
import script from "./Modems.vue?vue&type=script&lang=js"
export * from "./Modems.vue?vue&type=script&lang=js"
import style0 from "./Modems.vue?vue&type=style&index=0&id=4f74b990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74b990",
  null
  
)

export default component.exports